import {Component, OnInit, OnDestroy, DoCheck, Input, EventEmitter, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {PlanModel} from '../../common/service/plan-model.model';
import {selectedPurpose} from '../../lodge-field-record/lodge-field-record.model';
import {selectedLodgementType} from '../../lodge-field-record/lodge-field-record.model';
import {PlanType} from '../lodge-field-record.model';
import {isValidNumber, isValidString} from '../../common/service/data-util';

export interface SubjectPlan {
    planType: string;
    planNumber: number;
}

@Component({
    selector: 'nlr-field-record-subject-plans',
    imports: [FormsModule, CommonModule, NgSelectModule],
    templateUrl: './field-record-subject-plans.component.html',
    styleUrl: './field-record-subject-plans.component.scss'
})
export class FieldRecordSubjectPlansComponent implements OnInit, DoCheck, OnDestroy {
    checkAttrs = {purpose: ''};
    selectedPurposeSubjectPlanTypes = [];
    planModel: PlanModel = undefined;
    selectedPlanType = [];
    submitted = false;

    @Input()
    model: PlanModel;

    @Input()
    selectedPurpose: selectedPurpose;

    @Input()
    planTypes: PlanType[];

    @Input()
    selectedLodgementType: selectedLodgementType;

    @Output()
    validationChanged = new EventEmitter<boolean>();

    constructor() {}

    ngOnInit(): void {
        if (!this.model.subjectPlans) {
            this.model.subjectPlans = [{} as SubjectPlan];
        }

        if (this.model.subjectPlans.length < 1) {
            this.model.subjectPlans.push({} as SubjectPlan);
        }
    }

    ngDoCheck(): void {
        if (this.model) {
            if (this.model.purpose !== this.checkAttrs.purpose) {
                this.checkAttrs.purpose = this.model.purpose;
                this.selectedPlanType = [];
                this.model.subjectPlans = [];
                if (this.selectedPurpose) {
                    const selectedPurposeSubjectPlanTypeCodes = (this.selectedPurpose.subjectPlanType || '').split(',');
                    this.selectedPurposeSubjectPlanTypes = this.planTypes.filter(function (planType) {
                        return selectedPurposeSubjectPlanTypeCodes.indexOf(planType.id) !== -1;
                    });
                }
            }
            if (this.model.subjectPlans && this.model.subjectPlans.length < 1) {
                this.model.subjectPlans.push({} as SubjectPlan);
            }
        }
    }

    isPlanTypeValid(index: number) {
        return this.model.subjectPlans[index].planType === undefined || this.model.subjectPlans[index].planType === '' ? false : true;
    }

    ngOnDestroy(): void {
        // if (this.planModel.subjectPlans) {
        //     delete this.planModel.subjectPlans;
        // }
        // this.checkAttrs = {purpose: ''};
    }

    add(idx: number) {
        this.model.subjectPlans.splice(idx + 1, 0, {} as SubjectPlan);
    }

    remove(idx: number) {
        this.model.subjectPlans.splice(idx, 1);
        if (this.model.subjectPlans.length < 1) {
            this.model.subjectPlans.push({} as SubjectPlan);
        }
        this.checkUpdateLocalities();
    }

    checkUpdateLocalities() {
        if (this.selectedPurpose.formerTenure === 'Implied') {
            if (this.model.localities) {
                this.model.localities.length = 0;
            } else {
                this.model.localities = [];
            }

            this.model.localities.push({localityName: ''});
            //To-Do: nlrpFieldRecordLocalitiesService.getLotLocalitiesByLotRequestList needs to be invoked once the service is implemented
        }
    }

    updateSelectedPlanType(option: PlanType, index: number) {
        this.model.subjectPlans[index].planType = option.id;
        this.selectedPlanType[index] = option.name;
        if (this.model.subjectPlans[index].planType) this.validationChanged.emit(isValidString(option.id));
    }

    getPlanType(index: number) {
        return this.selectedPlanType[index];
    }

    onPlanNumberChange(newValue: number, index: number) {
        this.model.subjectPlans[index].planNumber = newValue;
        this.checkUpdateLocalities();
        if (this.model.subjectPlans[index].planNumber) this.validationChanged.emit(isValidNumber(newValue));
    }

    isSurveyTypeRequired() {
        return this.selectedPurpose ? this.selectedPurpose.subjectPlan === 'Mandatory' : false;
    }

    hasMinSubjectPlans() {
        return (
            !this.selectedLodgementType.applySubjectPlanValidation ||
            this.selectedPurpose.subjectPlan !== 'Mandatory' ||
            (this.selectedLodgementType.applySubjectPlanValidation &&
                this.model.subjectPlans &&
                this.model.subjectPlans.filter(function (subjectPlan) {
                    return subjectPlan.planType && subjectPlan.planNumber;
                }).length > 0)
        );
    }
}
